export default "__VITE_ASSET__Wfs5$MSC__"